export default __webpack_public_path__ + "static/media/Group 2032.65b3c493.png";